import { Locale, LocaleType } from "./Locale";

export type FittingType = "Standard" | "Detailed";
export type SpeedUnits = "MPH" | "M/S";
export type DistanceUnits = "Yards" | "Meters";

export default class Fitter {
    //note: Language is from cognito (e.g. English) and locale is for react-intl (e.g. en-US)
    constructor(public awsIdToken = "",
                public fitterID = 0, 
                public username = "", 
                public name = "", 
                public firstName = "", 
                public lastName = "", 
                public email = "", 
                public password = "", 
                public shotsPerClub = 3, 
                public fittingType: FittingType = "Standard", 
                public speedUnits: SpeedUnits = "MPH", 
                public distanceUnits: DistanceUnits = "Yards",
                public useEstimateDynamicLoft = false, 
                public useEstimateNoClubMeasurement = false, 
                public showCarry = false, 
                public language = "English", 
                public regionID = "", 
                public locationID = 0, 
                public locationName = "", 
                public country = "", 
                public locale: LocaleType = Locale.english, 
                public timezone = "", 
                public venueName = "", 
                public accountNumber = "",
                public hideGolferEmail = false, 
                public cognitoUserName = "", 
                public userPool = 0, 
                public authTimeEpoch = 0, 
                public refreshToken = "", 
                public iOS = false, 
                public deviceKey = "", 
                public firstLogin = true, 
                public groups = "",
                public showSm11 = true) {}
}
